<script>
  import { defineAsyncComponent, ref, watch } from 'vue';

  import NotificationToast from '@/components/NotificationToast.vue';

  import useAddressEntry from '@/composables/useAddressEntry';

  export default {
    name: 'App',
    components: {
      NotificationToast,
      AddressEntryModal: defineAsyncComponent(() => import('@/components/AddressEntryModal.vue')),
    },
    setup() {
      const { isAddressEntryOpen } = useAddressEntry();
      // Loaded on the first CTA click, so the dialog and Places code stay out of the initial bundle
      const isAddressEntryLoaded = ref(false);
      watch(isAddressEntryOpen, (isOpen) => {
        if (isOpen) isAddressEntryLoaded.value = true;
      });
      return { isAddressEntryLoaded };
    },
  };
</script>

<template>
  <!-- Notification Toast Component -->
  <NotificationToast />
  <router-view v-slot="{ Component }">
    <component :is="Component" />
  </router-view>
  <AddressEntryModal v-if="isAddressEntryLoaded" />
</template>

<style>
  /* Google injects .pac-container at the body level, so it is styled globally;
     z-index keeps it above the PrimeVue dialog mask */
  .pac-container {
    z-index: 1200;
    margin-top: 8px;
    padding: 6px;
    border: 1px solid #e2e8f0;
    border-radius: 16px;
    background-color: #ffffff;
    box-shadow: 0 20px 45px -20px rgba(45, 62, 80, 0.35);
    overflow: hidden;
    font-family: 'Montserrat', sans-serif;
  }

  /* Google sometimes sets border-radius inline; keep our rounded corners. */
  .pac-container[style] {
    border-radius: 16px !important;
  }

  .pac-item {
    padding: 10px 14px;
    border: none;
    border-radius: 10px;
    font-size: 13px;
    line-height: 1.4;
    color: #0f0202;
    cursor: pointer;
    transition:
      background-color 0.15s ease,
      color 0.15s ease;
  }

  .pac-item:hover,
  .pac-item-selected,
  .pac-item-selected:hover {
    background-color: rgb(179 239 255 / 0.35);
    color: #1d40be;
  }

  .pac-item-query {
    font-size: 13px;
    font-weight: 600;
    color: #2450ed;
  }

  .pac-matched {
    font-weight: 700;
    color: #2450ed;
  }

  /* Hide the default location-pin glyph; the field already shows its own marker. */
  .pac-icon {
    display: none;
  }

  /* "Powered by Google" attribution is REQUIRED by the Places API terms.
     Keep it visible; only make it a touch more subtle so it fits the dropdown. */
  .pac-logo:after {
    opacity: 0.7;
    padding-right: 14px;
    padding-bottom: 6px;
  }
</style>
